/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const plot = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeDasharray="2 3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.5 5a.61.61 0 0 1 .598.49l1.663 8.314A1 1 0 0 1 13.78 15H2.22a1 1 0 0 1-.98-1.196L2.901 5.49A.61.61 0 0 1 3.5 5"
    />
    <path
      fill="#000"
      d="m8.394 8.807-.592-.46.592.46Zm-.175.142-.33-.673.33.673Zm-.438 0 .33-.673-.33.673Zm-.175-.142.593-.46-.593.46ZM8 1v.75a2.24 2.24 0 0 1 1.59.663l.531-.529.532-.529A3.74 3.74 0 0 0 8 .25V1Zm2.121.884-.532.529c.423.425.661 1.002.661 1.606h1.5a3.78 3.78 0 0 0-1.097-2.664l-.532.53ZM11 4.02h-.75c0 .171-.066.456-.233.852a9.98 9.98 0 0 1-.656 1.243 25.053 25.053 0 0 1-1.56 2.233l.593.46.592.46a26.491 26.491 0 0 0 1.657-2.375 11.4 11.4 0 0 0 .755-1.437c.194-.459.352-.964.352-1.436H11ZM8.394 8.807l-.593-.46a.25.25 0 0 1 .088-.071l.33.673.33.673a1.25 1.25 0 0 0 .438-.356l-.593-.46Zm-.175.142-.33-.673A.253.253 0 0 1 8 8.25v1.5c.19 0 .379-.044.55-.128l-.33-.673ZM8 9v-.75c.038 0 .077.009.112.026l-.331.673-.33.673c.17.084.359.128.549.128V9Zm-.22-.05.331-.674a.25.25 0 0 1 .088.07l-.593.46-.593.46c.117.15.267.273.438.356l.33-.673Zm-.174-.143.592-.46a25.017 25.017 0 0 1-1.56-2.233 9.933 9.933 0 0 1-.654-1.243c-.168-.396-.234-.68-.234-.852h-1.5c0 .472.158.977.352 1.436.2.473.47.967.755 1.437.571.94 1.242 1.842 1.657 2.375l.592-.46ZM5 4.019h.75c0-.604.238-1.181.66-1.606l-.531-.529-.532-.529A3.778 3.778 0 0 0 4.25 4.02H5Zm.879-2.135.532.529A2.24 2.24 0 0 1 8 1.75V.25a3.74 3.74 0 0 0-2.653 1.105l.532.53ZM8.5 3.851h-.75c0-.132.108-.247.25-.247v1.5c.695 0 1.25-.565 1.25-1.253H8.5Zm-.5.503v-.75c.142 0 .25.115.25.247h-1.5c0 .688.555 1.253 1.25 1.253v-.75Zm-.5-.503h.75a.248.248 0 0 1-.25.247v-1.5c-.695 0-1.25.565-1.25 1.253h.75Zm.5-.503v.75a.248.248 0 0 1-.25-.247h1.5c0-.688-.555-1.253-1.25-1.253v.75Zm0 1.006h.75V3.348h-1.5v1.006H8Z"
    />
  </svg>
)
export default plot
